import { useState } from "react";
import { useTranslation } from "react-i18next";

import { StoppageDto } from "../../../DTOs/Stoppage/StoppageDto";
import { ExpandableTextarea } from "../../../components/ExpandableTextarea/ExpandableTextarea";
import { useIsReadOnly } from "../../../utilities/helpers/roleUtilities";

type RepairsFaultsCellProps = {
  stoppage: StoppageDto
  handleRepairFaultsChange: (stoppage: StoppageDto) => Promise<void>
}

const RepairsFaultsCell: React.FC<RepairsFaultsCellProps> = ({ stoppage, handleRepairFaultsChange }) => {
  const { t } = useTranslation("stoppages");
  const isReadOnly = useIsReadOnly();
  const [textState, setTextState] = useState<string>(stoppage.repairsFaults || '');

  return (
    <div className="w-full">
      <ExpandableTextarea
        value={textState}
        disabled={isReadOnly}
        placeholder={t("cells.noRepairsFaults")}
        onChange={(e) => setTextState(e.target.value)}
        onSubmit={async () => {
          await handleRepairFaultsChange(new StoppageDto({ ...stoppage, repairsFaults: textState }));
        }}
      />
    </div>
  )
}

export default RepairsFaultsCell